module.exports = __webpack_public_path__ + "img/personal.e139855f.png";